import type { CoreUserDDB } from '../interfaces/user.interface';

export const initialGetUserState: CoreUserDDB = {
  newUser: undefined,
  username: '',
  id: '',
  interests: [],
  lastActive: undefined,
  firstName: '',
  lastName: '',
  memberSince: '',
  companyName: '',
  jobTitle: '',
  phoneNumber: '',
  email: '',
  country: '',
  zipPostalCode: '',
  role: undefined,
  active: false,
  avatar: '',
  bio: '',
  createdAt: '',
  drafts: undefined,
  reputation: {
    sentiment: '',
    volatilityIndex: '',
    metrics: {
      following: [''], // referenced by IDs
      followers: [''], // referenced by IDs
    },
  },
  userPreferences: {
    theme: undefined,
    landingPage: undefined,
  },
};
